// @ts-nocheck

import memoize from 'memoize-state';
import React from 'react';
import { useSelector } from 'react-redux';

import { Target } from '../../../client';
import useMergeProps from '../../../hooks/useMergeProps';
import GridsPrizepool from '../components/GridsPrizepool';
import { getGrid } from '../selectors/grids';
import { getPool } from '../selectors/pool';
import Pool from '../states/pool';

const legacySelector = memoize((state, { poolId, gridReference }) => {
  const grid = (gridReference && getGrid(state, gridReference)) || null;
  const pool = getPool(state, poolId || grid?.poolId);
  const isOpen = Pool.isOpen(pool);
  const isLive = Pool.isLive(pool);

  const addedAmount = pool?.addedAmount;
  const netStakes = (isOpen || isLive) && (pool?.netStakes || 0) + (addedAmount || 0);
  const postponedAmount = pool?.postponedAmount;
  const distributedAmount = pool?.distributedAmount || pool?.prizepoolAmount;
  const guaranteedAmount = pool?.guaranteedAmount;

  const onlyGuarenteed = !Target.__MOBILE__ && !gridReference && isOpen && Pool.isCollectedHigherThanGuaranty(pool); // for desktop basket

  return {
    netStakes,
    addedAmount,
    postponedAmount,
    distributedAmount,
    guaranteedAmount,
    onlyGuarenteed,
  };
});

type GridsPrizepoolContainerProps = {
  className?: string;
  poolId?: number;
  gridReference?: string;
};

const GridsPrizepoolContainer = ({ poolId, gridReference, ...ownProps }: GridsPrizepoolContainerProps) => {
  const selectedProps = useSelector((state) => legacySelector(state, { poolId, gridReference }));

  const enhancedProps = useMergeProps({ ownProps, selectedProps });

  return <GridsPrizepool {...enhancedProps} />;
};

export default GridsPrizepoolContainer;
